
<template>
  <transition name="modal">
   <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <button class="float-right no-outline p-1 text-white bg-gray-600 hover:bg-gray-700 text-xs" v-on:click.prevent="close()">
                X
              </button>
          </div>

          <div class="modal-body">
            <slot name="body">
              How long should the trial be extended?
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
                  <select v-model="duration" class="border border-gray-500 bg-white no-outline ml-4">
                    <option value="7 days">7 days</option>
                    <option value="30 days">30 days</option>
                    <option value="60 days">60 days</option>
                    <option value="90 days">90 days</option>
                    <option value="6 months">6 months</option>
                    <option value="12 months">12 months</option>
                  </select>
              <button class="modal-default-button no-outline p-2 text-white bg-blue-600 hover:bg-blue-700 text-xs" v-on:click.prevent="extend()">
                Extend Trial
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>

  </transition>
</template>

<script>

  import { EventBus } from '@/shared/event-bus';

  export default {

    props: {
      plannerId: {
        type: Number,
        required : true
      }
    },

    data() {
      return {
        duration : '7 days' // default value
      }
    },

    methods : {

      close : function () {
        EventBus.$emit('close-extendtrial-modal');
      },

      extend : function() {
        var data = {plannerId: this.plannerId, duration : this.duration};
        EventBus.$emit('extend-trial', data);
      }
    }

  }
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px 40px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  font-size : 10px;
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  font-size: 20px;
}

.modal-default-button {
  float: right;
  width : 100px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
